import React from 'react';
import TransitionFormFields from './TransitionFormFields';
import { transitionSchema } from '../../../lib/transition-schemas';

export default function DormantForm({ values, onChange, errors }) {
  return <TransitionFormFields schema={transitionSchema('dormant')} values={values} onChange={onChange} errors={errors} />;
}
